var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKidneyCardE1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 158,
    height: 158,
    rx: 12,
    fill: "#fff",
    stroke: "#36B37E",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.756 119.94C1.391 103.472 16.925 47.882 44.253 38.7c11.338-3.81 23.843 8.83 23.767 16.676-.036 3.393-1.801 6.703-3.642 10.15-2.413 4.528-4.957 9.29-3.877 14.8 1.902 9.704 4.033 26.079-1.457 33.849-5.49 7.774-11.008 8.809-18.288 5.765zM119.745 38.7c27.329 9.182 42.866 64.772 3.497 81.24-7.28 3.048-12.798 2.009-18.288-5.765-5.49-7.77-3.359-24.145-1.456-33.85 1.079-5.509-1.464-10.275-3.878-14.8-1.84-3.446-3.605-6.757-3.638-10.15-.08-7.845 12.429-20.486 23.763-16.676zM98.986 91.284l.254 3.584h.043l.011-.004c-.205.03-.409.073-.608.13a5.643 5.643 0 0 0-1.714.812c-1.051.74-2.595 2.386-2.595 6.541V124a2 2 0 0 1-2 2H89.13a2 2 0 0 1-2-2v-21.653c0-6.347 2.573-10.232 5.635-12.4a12.935 12.935 0 0 1 5.29-2.167c.192-.03.386-.054.58-.072l.058-.007h.04c0-.003.007-.003.253 3.584zM65.012 91.284c-.246 3.584-.25 3.584-.254 3.584h-.043l-.01-.004.086.01c.804.145 1.567.462 2.236.928 1.05.744 2.594 2.39 2.594 6.545V124a2 2 0 0 0 2 2h3.247a2 2 0 0 0 2-2v-21.653c0-6.347-2.572-10.232-5.638-12.4a12.927 12.927 0 0 0-5.29-2.167 9.037 9.037 0 0 0-.58-.072l-.054-.007h-.04c0-.003-.004-.003-.254 3.584z",
    fill: "#CA8484"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidneyCardE1);
export default __webpack_public_path__ + "static/media/kidneyCardE1.ec6c46c8.svg";
export { ForwardRef as ReactComponent };